// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
import registerComponents from './components';
let module = angular.module('app.pages.complete-migration', []);

module.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state('complete-migration', {
      url: '/complete-migration',
      template: require('./complete-migration.html'),
      controller: require('./complete-migration').default,
      controllerAs: 'vm',
    })
    .state('complete-migration.welcome', {
      url: '/welcome',
      template: require('./welcome.html'),
      controller: require('./welcome').default,
      controllerAs: 'vm',
    })
    .state('complete-migration.account-info', {
      url: '/account-info',
      template: require('./account-info.html'),
      controller: require('./account-info').default,
      controllerAs: 'vm',
    })
    .state('complete-migration.video-organization', {
      url: '/video-organization',
      template: require('./video-organization.html'),
      controller: require('./video-organization').default,
      controllerAs: 'vm',
    })
    .state('complete-migration.migration-progress', {
      url: '/migration-progress',
      template: require('./migration-progress.html'),
      controller: require('./migration-progress').default,
      controllerAs: 'vm',
    })
    .state('complete-migration.plan-enrollment', {
      url: '/plan-enrollment',
      template: require('./plan-enrollment.html'),
      controller: require('./plan-enrollment').default,
      controllerAs: 'vm',
    })
    .state('complete-migration.success', {
      url: '/success',
      template: require('./success.html'),
      controller: require('./success').default,
      controllerAs: 'vm',
    });
});

registerComponents(module);

export default module;



// WEBPACK FOOTER //
// ./app/pages/complete-migration/_index.js